module.exports = __webpack_public_path__ + "media/hero_av1_1080.b250a4db.webm";